import { Layout, Content, Header, FormContent } from '@/components/SettingsLayout';
import styles from './styles.module.css';
import { SkeletonCustom } from '@/components/SkeletonLoader/SkeletonElements';

const DashboardSkeleton = () => {
  return (
    <Layout>
      <Content size='large'>
        <div className={styles.welcomeDiv}>
          <SkeletonCustom width={100} widthSelector='%' height={200} heightSelector='px' />
        </div>
        <div className={styles.dashBoardContainer}>
          <div className={styles.dashBoardLeft}>
            <div className={styles.leftSideContent}>
              <div className={styles.chartContainer}>
                <Header>
                  <SkeletonCustom width={200} widthSelector='px' height={32} heightSelector='px' />
                  <div className={styles.selectContainer}>
                    <SkeletonCustom width={100} widthSelector='%' height={32} heightSelector='px' />
                  </div>
                </Header>
                <div className={styles.chartHolder}>
                  <SkeletonCustom width={100} widthSelector='%' height={200} heightSelector='px' />
                </div>
                <div className={styles.gridContainer}>
                  <SkeletonGridCard />
                  <SkeletonGridCard />
                  <SkeletonGridCard />
                  <SkeletonGridCard />
                  <SkeletonGridCard />
                  <SkeletonGridCard />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.dashBoardRight}>
            <FormContent>
              <div className={styles.gridContainer}>
                <SkeletonCustom width={110} height={109} />
                <SkeletonCustom width={110} height={109} />
                <SkeletonCustom width={110} height={109} />
              </div>
            </FormContent>
            <SkeletonCustom width={200} height={32} />
            <SkeletonCustom width={100} widthSelector='%' height={100} />
            <SkeletonCustom width={100} widthSelector='%' height={100} />
            <SkeletonCustom width={100} widthSelector='%' height={100} />
          </div>
        </div>
      </Content>
    </Layout>
  );
};

export default DashboardSkeleton;

const SkeletonGridCard = () => {
  return (
    <div className={styles.gridItemContainer}>
      <SkeletonCustom width={60} height={60} />
      <div className={styles.textContainer}>
        <SkeletonCustom width={40} height={32} />
      </div>
    </div>
  );
};
